import { ActivePoolStatuses } from 'features/settings-view/components/Sub-views/SeasonsView/SeasonsView';
import * as yup from 'yup';
import { AnyObject } from 'yup/lib/types';
import { twoDecimalNullableSchema } from './common';

type NumberSchema = yup.NumberSchema<
  number | null | undefined,
  AnyObject,
  number | null | undefined
>;

type BooleanSchema = yup.BooleanSchema<
  boolean | undefined,
  AnyObject,
  boolean | undefined
>;

/**
 * The yup validation schema for editing rates.
 *
 * @remarks Because of the dynamic nature of the settings rate forms keys, a lazy
 * schema is used. Once yup receives the form keys, we simply map the desired
 * validation schema to each key.
 */
export const ratesSchema = yup.lazy((values: Record<string, number>) => {
  const newSchema: Record<string, NumberSchema> = {};
  const dynamicKeys = Object.keys(values);

  dynamicKeys.forEach(key => {
    newSchema[key] = twoDecimalNullableSchema;
  });

  return yup.object(newSchema);
});

export const rangeSchema = yup.object({
  rangeStart: yup
    .number()
    .transform((_, val) => (!val ? null : Number(val)))
    .when('$minRangeStart', (minRangeStart, schema) =>
      schema.moreThan(minRangeStart, `Must be more than ${minRangeStart}.`),
    )
    .typeError('Number required.'),
  rangeEnd: yup
    .number()
    .transform((_, val) => (!val ? null : Number(val)))
    .moreThan(yup.ref('rangeStart'), 'Must be greater than start range.')
    .typeError('Number required.'),
});

export const addTransferRateSchema = yup.object({
  route: yup.string().nullable().required('Route required.').trim(),
  chargeTarps: yup.boolean(),
  range: yup.object().typeError('Range required.'),
});

export const poolsSchema = yup.lazy((values: ActivePoolStatuses) => {
  const newSchema: Record<string, BooleanSchema> = {};
  const dynamicKeys = Object.keys(values);

  dynamicKeys.forEach(key => {
    newSchema[key] = yup.boolean();
  });

  return yup.object(newSchema);
});

const codeRequired = yup.string().nullable().required('Code required.').trim();

export const addSubVarietySchema = yup.object({
  code: codeRequired,
  regVariety: yup.object().nullable(),
  orgVariety: yup.object().nullable(),
});

export const addRootstockSchema = yup.object({
  code: codeRequired,
});
